angular
  .module('estoffice.legacy')
  .controller('CustomizationCtrl', customizationCtrl);

function customizationCtrl($rootScope, $scope, $timeout, $mdDialog) {
  var types = ['', 'Text', 'Number', 'Date', 'Choice'];

  $scope.price = {
    items: [],
    attr: { name: '', begin: '', end: '' },
    addOption: function () {
      this.attr.options.push({});
    },
    add: function () {
      if (this.attr.name.trim != '') {
        this.items.push(this.attr);
        this.attr = { name: '', begin: '', end: '' };
      }
    },
    delete: function (selector) {
      angular.element(document.querySelector(selector)).remove();
    },
  };

  $scope.unit_custom_field = {
    items: [],
    attr: { type: 1, name: '', options: [{}, {}] },
    addOption: function () {
      this.attr.options.push({});
    },
    add: function () {
      this.attr.typeLabel = types[this.attr.type];
      if (this.attr.type != 4) {
        this.attr.options = [];
      }
      if (this.attr.name.trim != '') {
        this.items.push(this.attr);
        this.attr = { type: 1, options: [{}, {}] };
      }
    },
    delete: function (selector) {
      angular.element(document.querySelector(selector)).remove();
    },
  };

  $scope.lead_custom_field = {
    items: [],
    attr: { type: 1, name: '', options: [{}, {}] },
    addOption: function () {
      this.attr.options.push({});
    },
    add: function () {
      this.attr.typeLabel = types[this.attr.type];
      if (this.attr.type != 4) {
        this.attr.options = [];
      }
      if (this.attr.name.trim != '') {
        this.items.push(this.attr);
        this.attr = { type: 1, options: [{}, {}] };
      }
    },
    delete: function (selector) {
      angular.element(document.querySelector(selector)).remove();
    },
  };

  $scope.deal_custom_field = {
    items: [],
    attr: { type: 1, name: '', options: [{}, {}] },
    addOption: function () {
      this.attr.options.push({});
    },
    add: function () {
      this.attr.typeLabel = types[this.attr.type];
      if (this.attr.type != 4) {
        this.attr.options = [];
      }
      if (this.attr.name.trim != '') {
        this.items.push(this.attr);
        this.attr = { type: 1, options: [{}, {}] };
      }
    },
    delete: function (selector) {
      angular.element(document.querySelector(selector)).remove();
    },
  };

  $scope.deal_cancelation_custom_field = {
    items: [],
    attr: { type: 1, name: '', options: [{}, {}] },
    addOption: function () {
      this.attr.options.push({});
    },
    add: function () {
      this.attr.typeLabel = types[this.attr.type];
      if (this.attr.type != 4) {
        this.attr.options = [];
      }
      if (this.attr.name.trim != '') {
        this.items.push(this.attr);
        this.attr = { type: 1, options: [{}, {}] };
      }
    },
    delete: function (selector) {
      angular.element(document.querySelector(selector)).remove();
    },
  };

  $scope.unit_status = {
    items: [],
    attr: { id: '', name: '', type: 1 },
    add: function () {
      if (this.attr.name.trim != '') {
        this.items[this.attr.type].push(this.attr);
        this.attr = { id: '', name: '', type: '1' };
      }
    },
    delete: function (selector) {
      //      angular.element( document.querySelector(selector) ).remove();
    },
  };

  $scope.label = {
    items: [],
    attr: { label_name: '', abbr: '' },
    add: function () {
      if (this.attr.label_name.trim != '') {
        this.items.push(this.attr);
        this.attr = { label_name: '', abbr: '' };
      }
    },
    delete: function (selector) {
      angular.element(document.querySelector(selector)).remove();
    },
  };

  $scope.lead_status = {
    items: [],
    attr: { type: 1, name: '' },
    add: function () {
      if (this.attr.name.trim != '') {
        this.items.push(this.attr);
      }
    },
    delete: function (selector) {
      angular.element(document.querySelector(selector)).remove();
    },
  };
}
